import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <h1 className="font-heading text-7xl md:text-9xl font-black text-primary-200 select-none">404</h1>
      <h2 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950">
        页面不存在或已被移除
      </h2>
      <p className="mt-2 text-sm text-foreground-500">找不到路径：{location.pathname}</p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold hover:bg-accent-400 transition-colors cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category"
          className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer"
        >
          <i className="ri-grid-line"></i>
          浏览影视分类
        </Link>
      </div>
    </div>
  );
}